import { render, staticRenderFns } from "./TransferwisePaymentBody.vue?vue&type=template&id=0b57e3a3&scoped=true&"
import script from "./TransferwisePaymentBody.vue?vue&type=script&lang=ts&"
export * from "./TransferwisePaymentBody.vue?vue&type=script&lang=ts&"
import style0 from "./TransferwisePaymentBody.vue?vue&type=style&index=0&id=0b57e3a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b57e3a3",
  null
  
)

export default component.exports